function extractVueFunctions () {
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"frontmatter-markdown"},[_c('p',[_vm._v("My hub for everything related to WoW's auction house. A replacement for "),_c('a',{attrs:{"href":"https://theunderminejournal.com"}},[_vm._v("The Undermine Journal")]),_vm._v(" which isn't suited for large multi-server based auction house operations and does not provide detailed enough information and predictions.")])])}]

return { render: render, staticRenderFns: staticRenderFns }
}
const vueFunctions = extractVueFunctions()

module.exports = { 
      attributes: {"name":"MyAH","tech":["Django","SQL","Materialize CSS"],"cover":"myah.png","github":"https://github.com/pizzadudez/MyAH","readme":false},
    
      body: "My hub for everything related to WoW's auction house. A replacement for [The Undermine Journal](https://theunderminejournal.com) which isn't suited for large multi-server based auction house operations and does not provide detailed enough information and predictions.\r\n",
    
      vue: {
        component: {
          data: function () {
            return {
              templateRender: null
            }
          },
          render: function (createElement) {
            return this.templateRender ? this.templateRender() : createElement("div", "Rendering");
          },
          created: function () {
            this.templateRender = vueFunctions.render;
            this.$options.staticRenderFns = vueFunctions.staticRenderFns;
          }
        }
      },
     }